import WashTask from "./WashTask";

export default WashTask;